import React from 'react';

import CarIcon from '../iconComponents/icons/CarIcon';
import HomeIcon from '../iconComponents/icons/HomeIcon';
import LuggageIcon from '../iconComponents/icons/LuggageIcon';
import MedicalIcon from '../iconComponents/icons/MedicalIcon';
import PawIcon from '../iconComponents/icons/PawIcon';
import ShieldIcon from '../iconComponents/icons/ShieldIcon';
import { IconProps } from '../iconComponents/types';

/**
 * Enum representing different lines of business
 */
export enum LINE_OF_BUSINESS {
  AUTO = 'auto',
  PET = 'pet',
  HOME = 'home',
  TRAVEL = 'travel',
  INSURANCE = 'insurance', // TODO: rename to something else
  MEDICAL = 'medical',
}

/**
 * Mapping from line of business to corresponding icon component
 */
export const LINE_OF_BUSINESS_ICON_MAP: Record<LINE_OF_BUSINESS, React.FC<IconProps>> = {
  [LINE_OF_BUSINESS.AUTO]: CarIcon,
  [LINE_OF_BUSINESS.PET]: PawIcon,
  [LINE_OF_BUSINESS.HOME]: HomeIcon,
  [LINE_OF_BUSINESS.TRAVEL]: LuggageIcon,
  [LINE_OF_BUSINESS.INSURANCE]: ShieldIcon,
  [LINE_OF_BUSINESS.MEDICAL]: MedicalIcon,
};
